<template>
  <SubmitButtonMagenta
    v-allowed.editor
    :loading="loading"
    spinner-color="#fff"
    @click="postTemplate"
  >
    {{ buttonText }}
  </SubmitButtonMagenta>
</template>

<script>
// Utils
import { checkApiResponse } from 'Utils'
import { Notification } from 'Utils/Classes/Notification'
import TemplateButtonMixin from '../mixins/templatesButtons'

// Preparing notification
const notification = new Notification()
notification.timeout = 4000

export default {
  name: 'TemplatesPublishButton',

  mixins: [TemplateButtonMixin],

  methods: {
    async postTemplate() {
      this.toggleLoadingStatus()

      const notifiactionMsg = `Plantilla ${this.notificationText} con éxito`
      const post = await this.$store.dispatch('templates/updateTemplateDraft', {
        status: 'published',
      })

      if (!checkApiResponse(post)) {
        notification.type = 'error'
        this.toggleLoadingStatus()
        return post
      }
      // if (this.mainTemplate.status !== 'published') {
      //   this.$router.push({ name: 'templates-listing' })
      // }
      this.$router.push({ name: 'templates-listing' })

      // sending notification
      notification.type = 'success'
      notification.message = notifiactionMsg
      notification.dispatch()
      // this.toggleLoadingStatus()
    },
  },
  computed: {
    template() {
      return this.$store.state.templates.templateDraft
    },

    mainIsPublished() {
      return !this.template.main && this.template.status === 'draft'
    },

    buttonText() {
      return this.mainIsPublished ? 'Actualizar' : 'Publicar'
    },

    notificationText() {
      return this.mainIsPublished ? 'actualizada' : 'publicada'
    },
  },
}
</script>

<style scoped></style>
